import React from 'react'
import { useTranslation } from 'react-i18next'
import '../../util/i18n'
import { useSelector } from 'react-redux'
import { selectUserCallStatus } from '../../features/user/userSlice'
import { selectUserPhone } from './userPhoneSlice'
import isMobileView from '../../util/MobileView'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import EditPhoneDesktop from './EditPhoneDesktop'
import EditPhoneMobile from './EditPhoneMobile'
import EditPhoneManager from './EditPhoneManager'

export function EditPhoneNumber() {
  const { t } = useTranslation()
  const userCallStatus = useSelector(selectUserCallStatus)
  const {
    currentCountry, phoneNumber, currentCountryPhoneCode, formattedPhone, phoneField, status
  } = useSelector(selectUserPhone)

  const {
    handleSubmit,
    handleChange,
    handleCountryCode,
    removeSessionStorage,
    isAPhoneNumber,
    userHasNumber,
    handleDelete,
    isDeleting,
    isTouched,
    setIsTouched,
    supportText,
    setSupportText,
    triedValidate,
    hasError,
    errorMessage,
    settriedValidate,
    isSaving,
    setIsAPhoneNumber
  } = EditPhoneManager()

  return (
    <MarginWrapper>
      {isMobileView() ? (
        <EditPhoneMobile
          currentCountry={currentCountry}
          currentCountryPhoneCode={currentCountryPhoneCode}
          userCallStatus={userCallStatus}
          phoneNumber={phoneNumber}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          handleCountryCode={handleCountryCode}
          removeSessionStorage={removeSessionStorage}
          isAPhoneNumber={isAPhoneNumber}
          userHasNumber={userHasNumber}
          handleDelete={handleDelete}
          isDeleting={isDeleting}
          isTouched={isTouched}
          setIsTouched={setIsTouched}
          supportText={supportText}
          setSupportText={setSupportText}
          triedValidate={triedValidate}
          settriedValidate={settriedValidate}
          hasError={hasError}
          errorMessage={errorMessage}
          t={t}
          isSaving={isSaving}
          setIsAPhoneNumber={setIsAPhoneNumber}
          formattedPhone={formattedPhone}
          phoneField={phoneField}
          phoneCallStatus={status}
        />
      ) : (
        <EditPhoneDesktop
          currentCountry={currentCountry}
          currentCountryPhoneCode={currentCountryPhoneCode}
          userCallStatus={userCallStatus}
          phoneNumber={phoneNumber}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          handleCountryCode={handleCountryCode}
          removeSessionStorage={removeSessionStorage}
          isAPhoneNumber={isAPhoneNumber}
          userHasNumber={userHasNumber}
          handleDelete={handleDelete}
          isDeleting={isDeleting}
          isTouched={isTouched}
          setIsTouched={setIsTouched}
          supportText={supportText}
          setSupportText={setSupportText}
          triedValidate={triedValidate}
          settriedValidate={settriedValidate}
          hasError={hasError}
          errorMessage={errorMessage}
          t={t}
          isSaving={isSaving}
          setIsAPhoneNumber={setIsAPhoneNumber}
          formattedPhone={formattedPhone}
          phoneField={phoneField}
          phoneCallStatus={status}
        />
      )}
    </MarginWrapper>
  )
}
